import {styled} from "@mui/material/styles";
import {Box, IconButton} from "@mui/material";

export const CloseButton = styled(IconButton)(({theme}) => ({
    width: '30px',
    height: '30px',
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
}));

export const CloseButtonContainer = styled(Box)(({theme}) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
}));